import { PERMISSIONS } from './permissions.constant';

/**
 * Declares which permission string is required for each Rentals action.
 *
 * RENTALS             → Owner / Manager  (full access)
 * RENTALS_OPERATIONAL → Frontdesk        (operational actions only)
 * Instructor          → no permission granted, no access
 *
 * The backend will enforce the same strings when real auth is added.
 * Components and the route guard read from here — never hardcode strings inline.
 */
export const RENTALS_PERMISSIONS = {
  // Module-level access (sidebar visibility + route guard)
  VIEW_MODULE: [PERMISSIONS.RENTALS, PERMISSIONS.RENTALS_OPERATIONAL],

  // Individual actions
  CREATE_RENTAL:    [PERMISSIONS.RENTALS, PERMISSIONS.RENTALS_OPERATIONAL],
  RETURN_EQUIPMENT: [PERMISSIONS.RENTALS, PERMISSIONS.RENTALS_OPERATIONAL],
  RESERVE_EQUIPMENT:[PERMISSIONS.RENTALS, PERMISSIONS.RENTALS_OPERATIONAL],
  ADD_PAYMENT:      [PERMISSIONS.RENTALS, PERMISSIONS.RENTALS_OPERATIONAL],
  EXTEND_RENTAL:    [PERMISSIONS.RENTALS],
  SWAP_EQUIPMENT:   [PERMISSIONS.RENTALS],
  REPORT_DAMAGE:    [PERMISSIONS.RENTALS],
  CANCEL_RENTAL:    [PERMISSIONS.RENTALS, PERMISSIONS.RENTALS_OPERATIONAL],
} as const;

/**
 * Mock permission sets by role.
 * Replace the contents of each array with real backend values when auth is ready.
 * AuthService.loadPermissions() already consumes this format.
 */
export const MOCK_PERMISSIONS_BY_ROLE: Record<string, string[]> = {
  owner: [
    PERMISSIONS.RENTALS,
    PERMISSIONS.RENTALS_OPERATIONAL,
  ],
  manager: [
    PERMISSIONS.RENTALS,
    PERMISSIONS.RENTALS_OPERATIONAL,
  ],
  frontdesk: [
    PERMISSIONS.RENTALS_OPERATIONAL,
  ],
  instructor: [
    // No rentals access
  ],
};
